
import { Component, Vue } from 'vue-property-decorator';

@Component({})
export default class BeClient extends Vue {
  longClasses =
    'tab-nav tab-nav2 clearfix ui-tabs-nav ui-corner-all ui-helper-reset ui-helper-clearfix ui-widget-header row';
}
